import { render, staticRenderFns } from "./CreditTable.vue?vue&type=template&id=5d8b3e38&scoped=true&"
import script from "./CreditTable.vue?vue&type=script&lang=js&"
export * from "./CreditTable.vue?vue&type=script&lang=js&"
import style0 from "./CreditTable.vue?vue&type=style&index=0&id=5d8b3e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b3e38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VTooltip})
